module.exports = __webpack_public_path__ + "static/media/think-peaks.c0ffe0aa.svg";